"use strict";
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 95
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/implementation/web)
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ampli = exports.Ampli = exports.Ts1AppButtonClicked = exports.TeamSnapAccountBlocked = exports.TeamSubscriptionPricingViewed = exports.TeamSubscriptionInformationRequested = exports.TeamSubscriptionButtonClicked = exports.ScreenViewed = exports.RosterAddModeSelected = exports.PaidTeamSubscriptionViewed = exports.OnboardingButtonClicked = exports.MarketingScreenViewed = exports.FreeTeamSelected = exports.FamilyMemberInviteSent = exports.CreateTeamButtonClicked = exports.Identify = exports.DefaultConfiguration = exports.ApiKey = void 0;
const amplitude = __importStar(require("@amplitude/analytics-browser"));
exports.ApiKey = {
    tsprod: '882970ed62df6c660dd4ea7ec75d752e',
    tsdev: 'af29da91be780b53b878778f604b7db6',
};
/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
exports.DefaultConfiguration = {
    plan: {
        version: '95',
        branch: 'main',
        source: 'web',
        versionId: '81c8a525-b491-4bf8-8299-e36f23581613',
    },
    ...{
        ingestionMetadata: {
            sourceName: 'browser-typescript-ampli',
            sourceVersion: '2.0.0',
        },
    },
};
class Identify {
    event_properties;
    event_type = amplitude.Types.SpecialEventType.IDENTIFY;
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.Identify = Identify;
class CreateTeamButtonClicked {
    event_properties;
    event_type = 'Create Team Button Clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.CreateTeamButtonClicked = CreateTeamButtonClicked;
class FamilyMemberInviteSent {
    event_properties;
    event_type = 'Family Member Invite Sent';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.FamilyMemberInviteSent = FamilyMemberInviteSent;
class FreeTeamSelected {
    event_properties;
    event_type = 'Free Team Selected';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.FreeTeamSelected = FreeTeamSelected;
class MarketingScreenViewed {
    event_properties;
    event_type = 'Marketing Screen Viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.MarketingScreenViewed = MarketingScreenViewed;
class OnboardingButtonClicked {
    event_properties;
    event_type = 'Onboarding Button Clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.OnboardingButtonClicked = OnboardingButtonClicked;
class PaidTeamSubscriptionViewed {
    event_properties;
    event_type = 'Paid Team Subscription Viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.PaidTeamSubscriptionViewed = PaidTeamSubscriptionViewed;
class RosterAddModeSelected {
    event_properties;
    event_type = 'Roster Add Mode Selected';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.RosterAddModeSelected = RosterAddModeSelected;
class ScreenViewed {
    event_properties;
    event_type = 'Screen Viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.ScreenViewed = ScreenViewed;
class TeamSubscriptionButtonClicked {
    event_properties;
    event_type = 'Team Subscription Button Clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.TeamSubscriptionButtonClicked = TeamSubscriptionButtonClicked;
class TeamSubscriptionInformationRequested {
    event_properties;
    event_type = 'Team Subscription Information Requested';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.TeamSubscriptionInformationRequested = TeamSubscriptionInformationRequested;
class TeamSubscriptionPricingViewed {
    event_properties;
    event_type = 'Team Subscription Pricing Viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.TeamSubscriptionPricingViewed = TeamSubscriptionPricingViewed;
class TeamSnapAccountBlocked {
    event_properties;
    event_type = 'TeamSnap Account Blocked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.TeamSnapAccountBlocked = TeamSnapAccountBlocked;
class Ts1AppButtonClicked {
    event_properties;
    event_type = 'TS1 App Button Clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
exports.Ts1AppButtonClicked = Ts1AppButtonClicked;
const getVoidPromiseResult = () => ({ promise: Promise.resolve() });
// prettier-ignore
class Ampli {
    disabled = false;
    amplitude;
    get client() {
        this.isInitializedAndEnabled();
        return this.amplitude;
    }
    get isLoaded() {
        return this.amplitude != null;
    }
    isInitializedAndEnabled() {
        if (!this.amplitude) {
            console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
            return false;
        }
        return !this.disabled;
    }
    /**
     * Initialize the Ampli SDK. Call once when your application starts.
     *
     * @param options Configuration options to initialize the Ampli SDK with.
     */
    load(options) {
        this.disabled = options.disabled ?? false;
        if (this.amplitude) {
            console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
            return getVoidPromiseResult();
        }
        let apiKey = null;
        if (options.client && 'apiKey' in options.client) {
            apiKey = options.client.apiKey;
        }
        else if ('environment' in options) {
            apiKey = exports.ApiKey[options.environment];
        }
        if (options.client && 'instance' in options.client) {
            this.amplitude = options.client.instance;
        }
        else if (apiKey) {
            this.amplitude = amplitude.createInstance();
            const configuration = options.client && 'configuration' in options.client ? options.client.configuration : {};
            return this.amplitude.init(apiKey, undefined, { ...exports.DefaultConfiguration, ...configuration });
        }
        else {
            console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
        }
        return getVoidPromiseResult();
    }
    /**
     * Identify a user and set user properties.
     *
     * @param userId The user's id.
     * @param properties The user properties.
     * @param options Optional event options.
     */
    identify(userId, properties, options) {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        if (userId) {
            options = { ...options, user_id: userId };
        }
        const amplitudeIdentify = new amplitude.Identify();
        const eventProperties = properties;
        if (eventProperties != null) {
            for (const [key, value] of Object.entries(eventProperties)) {
                amplitudeIdentify.set(key, value);
            }
        }
        return this.amplitude.identify(amplitudeIdentify, options);
    }
    /**
     * Flush the event.
     */
    flush() {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        return this.amplitude.flush();
    }
    /**
     * Track event
     *
     * @param event The event to track.
     * @param options Optional event options.
     */
    track(event, options) {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        return this.amplitude.track(event, undefined, options);
    }
    /**
     * Create Team Button Clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/Create%20Team%20Button%20Clicked)
     *
     * Tracking user actions taken to create teams after their initial onboarding and first team creation. These buttons should reflect actions users take to create and setup their 2nd+n team. [Figma](https://www.figma.com/board/tsrNjuINMbDg829HuFBLe7/Analytics-Scoping---Web-Onboarding-with-Stripe?node-id=93-1154&t=TSLSyBySxPrtX4f8-0)
     *
     * Owner: jessica.irvin@teamsnap.com
     *
     * @param properties The event's properties (e.g. onboarding_button_name)
     * @param options Amplitude event options.
     */
    createTeamButtonClicked(properties, options) {
        return this.track(new CreateTeamButtonClicked(properties), options);
    }
    /**
     * Family Member Invite Sent
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/Family%20Member%20Invite%20Sent)
     *
     * Record when a user Invites a Family Member during the team invite acceptance flow.
     *
     * @param properties The event's properties (e.g. team_id)
     * @param options Amplitude event options.
     */
    familyMemberInviteSent(properties, options) {
        return this.track(new FamilyMemberInviteSent(properties), options);
    }
    /**
     * Free Team Selected
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/Free%20Team%20Selected)
     *
     * A client side event that tracks when a user clicks "Proceed with a free team" during plan selection on the team subscription pricing page
     *
     * Owner: jessica.irvin@teamsnap.com
     *
     * @param properties The event's properties (e.g. screen_name)
     * @param options Amplitude event options.
     */
    freeTeamSelected(properties, options) {
        return this.track(new FreeTeamSelected(properties), options);
    }
    /**
     * Marketing Screen Viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/Marketing%20Screen%20Viewed)
     *
     * A user views a www.teamsnap.com marketing page.
     *
     * Owner: Grayson Moss
     *
     * @param properties The event's properties (e.g. referrer)
     * @param options Amplitude event options.
     */
    marketingScreenViewed(properties, options) {
        return this.track(new MarketingScreenViewed(properties), options);
    }
    /**
     * Onboarding Button Clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/Onboarding%20Button%20Clicked)
     *
     * Any non-conversion CTAs present in the Onboarding funnel that we need to answer a specific business question outside of the core conversion path in team activation.
     *
     * Owner: jessica.irvin@teamsnap.com
     *
     * @param properties The event's properties (e.g. onboarding_button_name)
     * @param options Amplitude event options.
     */
    onboardingButtonClicked(properties, options) {
        return this.track(new OnboardingButtonClicked(properties), options);
    }
    /**
     * Paid Team Subscription Viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/Paid%20Team%20Subscription%20Viewed)
     *
     * The paid team subscription options have been viewed by the team owner during team creation or via the upgrade funnel at the end of the team's free trial.
     *
     * Owner: monisha.saldanha@teamsnap.com
     *
     * @param properties The event's properties (e.g. team_subscription_cadence)
     * @param options Amplitude event options.
     */
    paidTeamSubscriptionViewed(properties, options) {
        return this.track(new PaidTeamSubscriptionViewed(properties), options);
    }
    /**
     * Roster Add Mode Selected
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/Roster%20Add%20Mode%20Selected)
     *
     * A user clicks or taps on a roster add mode from the Add Team Member menu.
     *
     * Owner: allison.goodman@teamsnap.com
     *
     * @param properties The event's properties (e.g. roster_add_mode)
     * @param options Amplitude event options.
     */
    rosterAddModeSelected(properties, options) {
        return this.track(new RosterAddModeSelected(properties), options);
    }
    /**
     * Screen Viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/Screen%20Viewed)
     *
     * This event tracks when a screen is viewed by a user in the app. It provides general-purpose information about user engagement and navigation within the app
     *
     * Owner: Jenny Astrachan
     *
     * @param properties The event's properties (e.g. screen_name)
     * @param options Amplitude event options.
     */
    screenViewed(properties, options) {
        return this.track(new ScreenViewed(properties), options);
    }
    /**
     * Team Subscription Button Clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/Team%20Subscription%20Button%20Clicked)
     *
     * This event should be used on web when a user clicks one of the upgrade CTAs in the app.
     *
     * Owner: jessica.irvin@teamsnap.com
     *
     * @param properties The event's properties (e.g. screen_name)
     * @param options Amplitude event options.
     */
    teamSubscriptionButtonClicked(properties, options) {
        return this.track(new TeamSubscriptionButtonClicked(properties), options);
    }
    /**
     * Team Subscription Information Requested
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/Team%20Subscription%20Information%20Requested)
     *
     * The user taps on a Learn More or Upgrade CTA in the mobile app flow that triggers an email or web view.
     *
     * Owner: monisha.saldanha@teamsnap.com
     *
     * @param properties The event's properties (e.g. screen_name)
     * @param options Amplitude event options.
     */
    teamSubscriptionInformationRequested(properties, options) {
        return this.track(new TeamSubscriptionInformationRequested(properties), options);
    }
    /**
     * Team Subscription Pricing Viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/Team%20Subscription%20Pricing%20Viewed)
     *
     * This event should trigger when a user sees the stripe backed pricing table in the product UX.
     *
     * Owner: jessica.irvin@teamsnap.com
     *
     * @param properties The event's properties (e.g. basic_shown)
     * @param options Amplitude event options.
     */
    teamSubscriptionPricingViewed(properties, options) {
        return this.track(new TeamSubscriptionPricingViewed(properties), options);
    }
    /**
     * TeamSnap Account Blocked
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/TeamSnap%20Account%20Blocked)
     *
     * Event indicating that a user was denied creation of a TeamSnap account. This could be the result of age or country restrictions.
     *
     * @param properties The event's properties (e.g. block_reason)
     * @param options Amplitude event options.
     */
    teamSnapAccountBlocked(properties, options) {
        return this.track(new TeamSnapAccountBlocked(properties), options);
    }
    /**
     * TS1 App Button Clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/mojosports/Teamsnap%20for%20Teams/events/main/latest/TS1%20App%20Button%20Clicked)
     *
     * If user see the interstitial message to redirect to classic TeamSnap ONE app and they click on the CTA, this event will fire.
     *
     * @param properties The event's properties (e.g. screen_name)
     * @param options Amplitude event options.
     */
    ts1AppButtonClicked(properties, options) {
        return this.track(new Ts1AppButtonClicked(properties), options);
    }
}
exports.Ampli = Ampli;
exports.ampli = new Ampli();
